import FButtonPrevious from 'components/BaseComponents/FButton/FPreviousButton'
import SBox from 'components/opinionless/SBox'
import SText from 'components/opinionless/SText'
import { WIZARD_STEPS_MAPPING } from 'containers/Apply/LongBeachWizard'
import { updatePercentageAndStep } from 'v2/components/XProgressBar/utils'

import { LBButton, LBText } from 'containers/Apply/steps/ApplicationStepLBIntroduction'
import { useTranslation } from 'i18n'
import React from 'react'
import { StepWizardChildProps } from 'react-step-wizard'
import { SStyled, useSTheme } from 'styles/theme'
import { ga4_useTitle } from 'utils/ga4'
import XBanner from 'v2/components/XBanner'

const LBTextHeader = SStyled(SText)`
    ${(p) => `
        @media screen and (max-width: ${p.theme.breakpoints[0]}) {
            font-size: 24px;
            line-height: 130%;
        }
    `}
`

interface Props {
    setCurrentStep?: (number) => void
    fontFamily: any
    nextStep?: any
    onPrevious?: any
    updatePercentage: any
}

export const Container = SStyled(SBox)`
    width: 100%;
    max-width: 600px;
`

const DocumentsIntroduction: React.FC<Props> = (props: Props & StepWizardChildProps) => {
    const theme = useSTheme()
    const { t } = useTranslation(window.LANG_NS)
    ga4_useTitle('Household income')

    const fontFamily = props.fontFamily

    const { percentage, wizardStep, childWizzardStep } = updatePercentageAndStep(
        WIZARD_STEPS_MAPPING.documents,
        WIZARD_STEPS_MAPPING.documents.introduction,
        WIZARD_STEPS_MAPPING
    )
    props.updatePercentage(percentage, wizardStep, childWizzardStep)

    return (
        <Container>
            <SBox as="form" onSubmit={() => props.nextStep()}>
                <FButtonPrevious onClick={props.onPrevious} />
                <LBTextHeader
                    sx={{
                        textAlign: 'left',
                        fontSize: '32px',
                        color: theme.colors.secondaryColor,
                        fontFamily: fontFamily.header,
                    }}
                >
                    {t('long_beach_documents_header')}
                </LBTextHeader>
                <LBText
                    sx={{
                        textAlignLast: 'left',
                        whiteSpace: 'pre-line',
                        fontFamily: fontFamily.body,
                        fontWeight: '800',
                        lineHeight: '140%',
                        color: theme.colors.black,
                        fontSize: '16px',
                    }}
                >
                    {t('long_beach_documents_subheader')}
                </LBText>

                <LBText
                    sx={{
                        textAlignLast: 'left',
                        whiteSpace: 'pre-line',
                        fontFamily: fontFamily.body,
                        fontWeight: '400',
                        lineHeight: '140%',
                        color: theme.colors.gray400,
                        fontSize: '14px',
                        marginBottom: '24px',
                    }}
                    dangerouslySetInnerHTML={{
                        __html: t('long_beach_documents_intro'),
                    }}
                />
                <XBanner
                    title={t('have_more_questions')}
                    description={t('visit_faq')}
                    isButton={true}
                    isCloseButton={true}
                    buttonTitle={t('learn_more')}
                    type="info"
                    isLongBeachV2Design
                    isButtonDisabled={false}
                    buttonAction={() => {
                        window.open('https://www.commoninja.com/faq/lp/e4eded02-fec6-4dc2-b040-31e31fc9b518', '_blank')
                    }}
                />
                <LBButton
                    type={'submit'}
                    id={'continueButton'}
                    title={t('continue')}
                    width={'100%'}
                    mt={7}
                    mb={5}
                    textStyle={{
                        fontWeight: 700,
                        fontSize: '14px',
                        lineHeight: '140%',
                        fontFamily: fontFamily.body,
                        color: theme.colors.white,
                    }}
                >
                    {t('continue')}
                </LBButton>
            </SBox>
        </Container>
    )
}

export default DocumentsIntroduction
